import { FunctionComponent, useState } from "react";
import { WalletIcon } from "@/components/common/icons";
import Link from "next/link";
import { Divider, Menu, Drawer, Button } from "@mantine/core";
import { useRouter } from "next/router";
import { getRoute } from "@/services/config";
import useAccount from "@/hooks/useAccount";
import Image from "next/image";
import { trimAddr } from "@/utils/format";

import { tabs, menus, testNetworkMenus } from "@/components/common/AppMenu";

import { useNetwork, useSwitchNetwork } from "wagmi";

const AppMobileMenu: FunctionComponent = () => {
  const [drawerOpened, setDrawerOpened] = useState(false);
  const router = useRouter();
  const { login, logout, isLogin, address } = useAccount();
  const { chain } = useNetwork();
  const { switchNetwork } = useSwitchNetwork();

  return (
    <div
      className="relative z-10 h-[56px]"
      style={{
        filter: "drop-shadow(15px 4px 40px rgba(0, 0, 0, 0.1))",
      }}
    >
      <div className="bg-white ">
        <div className="layout-content flex h-[60px] items-center justify-between  px-5 md:px-14">
          <div
            className="action block sm:hidden"
            onClick={() => {
              setDrawerOpened(true);
            }}
          >
            <Image src={"/assets/burger.png"} width={18} height={15}></Image>
          </div>
          {isLogin && (
            <Menu shadow="md" position="bottom-end">
              <Menu.Target>
                <div>
                  <Button className={`btn-pri px-6 `}>
                    {trimAddr(address as string, 1)}
                  </Button>
                  {/* <WalletIcon className="fill-primary relative w-8 h-8"></WalletIcon> */}
                </div>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Label>Select a Network</Menu.Label>
                {menus.map((menu) => {
                  return (
                    <Menu.Item
                      key={menu.name}
                      icon={
                        <img
                          src={menu.icon}
                          alt="ethereum"
                          className="h-4 w-4"
                        />
                      }
                      onClick={() => {
                        // @ts-ignore
                        switchNetwork(menu.chain.id);
                      }}
                    >
                      <p className="font-bold">
                        {menu.name}
                        {chain?.id === menu.chain.id ? "(Active)" : null}
                      </p>
                    </Menu.Item>
                  );
                })}
                <Menu.Label>Test Network</Menu.Label>
                {testNetworkMenus.map((menu) => {
                  return (
                    <Menu.Item
                      key={menu.name}
                      icon={
                        <img
                          src={menu.icon}
                          alt="ethereum"
                          className="h-4 w-4"
                        />
                      }
                      onClick={() => {
                        // @ts-ignore
                        switchNetwork(menu.chain.id);
                      }}
                    >
                      <p className="font-bold">
                        {menu.name}
                        {chain?.id === menu.chain.id ? "(Active)" : null}
                      </p>
                    </Menu.Item>
                  );
                })}
                <Menu.Divider />
                <Menu.Item
                  onClick={() => navigator.clipboard.writeText(address || "")}
                >
                  Copy address
                </Menu.Item>
                <Menu.Item onClick={logout}>Disconnect wallet</Menu.Item>
              </Menu.Dropdown>
            </Menu>
          )}
          {!isLogin && (
            <Button className={`px-6`} onClick={login}>
              Connect
            </Button>
          )}
        </div>
      </div>
      <Drawer
        opened={drawerOpened}
        onClose={() => setDrawerOpened(false)}
        padding="xl"
        size="sm"
        trapFocus={false}
        withCloseButton={false}
        classNames={{
          root: "p-0",
          body: "h-full p-0",
          overlay: "!bg-[rgba(0,0,0,0.8)]",
        }}
      >
        <div className="w-full h-full flex-shrink-0 bg-dark1 px-4 py-6 flex flex-col">
          {[getRoute("dashboard")].map((tab: any) => {
            const isActive = router.pathname === tab.route;
            return (
              <Link href={`${tab.route}`} key={tab.id}>
                <div className="flex py-3 pb-0 action">
                  <tab.Icon
                    className={`${
                      isActive ? "fill-[#87B5FF]" : "fill-[#8F8F8F]"
                    }`}
                  ></tab.Icon>
                  <span
                    className={`ml-2 text-sm font-semibold ${
                      isActive ? "text-white" : "text-[#8F8F8F]"
                    }`}
                  >
                    {tab.label}
                  </span>
                </div>
              </Link>
            );
          })}
          <Divider color={"#3A3A3A"} className="mt-7"></Divider>
          <div className="py-4">
            {tabs.map((tab: any) => {
              const isActive = router.pathname.indexOf(tab.route) === 0;
              return (
                <Link href={`${tab.route}`} key={tab.id}>
                  <div className="flex py-3 action last:pb-0">
                    <tab.Icon
                      className={`${
                        isActive ? "fill-[#87B5FF]" : "fill-[#8F8F8F]"
                      }`}
                    ></tab.Icon>
                    <span
                      className={`ml-2 text-sm font-semibold ${
                        isActive ? "text-white" : "text-[#8F8F8F]"
                      }`}
                    >
                      {tab.label}
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default AppMobileMenu;
